import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const useAPISpoolPriceFeed = () => {
    const { interfaceSDK } = useContext(appContext);

    const { data, error } = useSWR(interfaceSDK ? 'apiSpoolPrice' : null, () =>
        interfaceSDK!.get.getSpoolUsdValue()
    );

    return {
        apiSpoolPriceFeed: data,
        isLoading: !error && !data,
        error,
    };
};

export default useAPISpoolPriceFeed;
